import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=32c5f4a8&scoped=true&shadow"
import script from "./Page.vue?vue&type=script&lang=js&shadow"
export * from "./Page.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "32c5f4a8",
  null
  ,true
)

export default component.exports